export const Constants = {
  ACS_CHANNEL: 'ACS_CHANNEL',
  API_Version: '2020-09-21-preview2'
};
